"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[131],{

/***/ 8340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _tippyjs_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2697);
/* harmony import */ var tippy_js_dist_tippy_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(465);
/* harmony import */ var tippy_js_dist_tippy_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(tippy_js_dist_tippy_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _likes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5939);
/* harmony import */ var _dropdown_Token_dropdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7229);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/* harmony import */ var _redux_counterSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8362);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(406);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9023);













var CategoryItem = function(param) {
    var tokens = param.tokens, collections = param.collections, noFeature = param.noFeature;
    if (!tokens) tokens = [];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_9__/* .useAlert */ .VY)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    var publicKey = (0,_demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_11__/* .useWallet */ .Os)().publicKey;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4",
        children: [
            tokens.lenght === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: "No items found"
            }),
            tokens.map(function(item) {
                var itemLink = item.hex_id;
                return item.collection ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/token/".concat(itemLink),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: item.metadata.image,
                                                alt: "item 5",
                                                className: "w-full h-[230px] rounded-[0.625rem] object-cover"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute left-3 -bottom-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex -space-x-2 hidden",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/collection/".concat(item.collection.hex_id),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tippyjs_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                                        className: "p-1",
                                                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            children: [
                                                                "[",
                                                                item.collection.public_data.metadata.ticker,
                                                                "] ",
                                                                item.collection.public_data.metadata.name
                                                            ]
                                                        }),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: item.collection.public_data.metadata.icon_url,
                                                            alt: "owner",
                                                            layout: "fill",
                                                            className: "dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-7 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/token/".concat(itemLink),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "font-display text-jacarta-700 text-base dark:text-white normal-case",
                                                children: item.metadata.name
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dropdown_Token_dropdown__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        collections: collections,
                                        token: item,
                                        classes: "dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "dark:text-jacarta-200 text-jacarta-400 mr-1 text-sm hover:text-accent",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/collection/".concat(item.collection.hex_id),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "block",
                                        style: {
                                            float: "left",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: item.collection.public_data.metadata.icon_url,
                                                alt: "owner",
                                                layout: "fill",
                                                className: "float-left block float-left dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-0 border-white",
                                                style: {
                                                    float: "left",
                                                    display: "inline-block",
                                                    marginRight: "3px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "grid float-left",
                                                children: [
                                                    "[",
                                                    item.collection.public_data.metadata.ticker,
                                                    "] ",
                                                    item.collection.public_data.metadata.name
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            !noFeature && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-8 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "text-accent font-display text-sm font-semibold block pl-[20px] pr-[20px] pt-[10px] pb-[10px] background-transparent hover:bg-accent hover:text-white border border-accent hover:border-transparent rounded-full",
                                        onClick: function() {
                                            if (item._record) {
                                                alert.error("You can only list public tokens. Transfer to public first.");
                                                router.push("/token/".concat(item.hex_id, "/transfer?dest=public&to=self"));
                                                return;
                                            }
                                            dispatch((0,_redux_counterSlice__WEBPACK_IMPORTED_MODULE_8__/* .bidsModalShow */ .$f)({
                                                token_id: item.hex_id,
                                                royalty_fees: item.collection.public_data.royalty_fees,
                                                is_update: false
                                            }));
                                        },
                                        children: "Sell"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/token/".concat(itemLink, "/transfer"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "group flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                    className: "icon icon-history group-hover:fill-accent dark:fill-jacarta-200 fill-jacarta-500 mr-1 mb-[3px] h-4 w-4",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                                        xlinkHref: "/icons.svg#icon-transfer"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "group-hover:text-accent font-display dark:text-jacarta-200 text-sm font-semibold",
                                                    children: "Transfer"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }, item.hex_id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: item.metadata.image,
                                    alt: "item 5",
                                    className: "w-full h-[230px] rounded-[0.625rem] object-cover"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-7 flex items-center justify-between",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-display text-jacarta-700 text-base dark:text-white",
                                    children: item.name
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "dark:text-jacarta-200 text-jacarta-400 mr-1 text-sm",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "block",
                                    style: {
                                        float: "left",
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "grid float-left",
                                        children: [
                                            "Edition: ",
                                            item.edition.slice(0, item.edition.length - 6)
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-8 flex items-center justify-between",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "text-accent font-display text-sm font-semibold block pl-[20px] pr-[20px] pt-[10px] pb-[10px] background-transparent hover:bg-accent hover:text-white border border-accent hover:border-transparent rounded-full",
                                    onClick: function() {
                                        dispatch((0,_redux_counterSlice__WEBPACK_IMPORTED_MODULE_8__/* .mintLeosModalShow */ .hu)({
                                            record: item._record
                                        }));
                                    },
                                    children: "Import"
                                })
                            })
                        ]
                    })
                }, item.name + item.edition);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryItem);


/***/ }),

/***/ 7229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _redux_counterSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8362);
/* harmony import */ var _demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9023);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6833);












function burnPP(publicKey, requestRecords, requestTransaction, token_record, router, alert, loading, setLoading) {
    return _burnPP.apply(this, arguments);
}
function _burnPP() {
    _burnPP = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(publicKey, requestRecords, requestTransaction, token_record, router, alert, loading, setLoading) {
        var response, data, res, e, ref, err_str;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loading || !token_record || !publicKey) return [
                        2
                    ];
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch("/api/v0/leos/burn/".concat(publicKey), {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    if (data.error) throw new Error(data.error);
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .transfer_private */ .Q2)(publicKey, requestRecords, requestTransaction, token_record, data.address)
                    ];
                case 4:
                    res = _state.sent();
                    alert.success("Transaction in progress.");
                    router.push("/transaction/status/leo/" + res);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    err_str = (e === null || e === void 0 ? void 0 : (ref = e.error) === null || ref === void 0 ? void 0 : ref.message) || (e === null || e === void 0 ? void 0 : e.message) || e + "";
                    alert.error(err_str);
                    console.log(err_str);
                    return [
                        3,
                        6
                    ];
                case 6:
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _burnPP.apply(this, arguments);
}
var Token_dropdown = function(param) {
    var classes = param.classes, token = param.token, collections = param.collections;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), dropdownShow = ref[0], setDropdownShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var is_private = token._record !== undefined;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_6__/* .useAlert */ .VY)();
    var ref2 = (0,_demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_5__/* .useWallet */ .Os)(), publicKey = ref2.publicKey, requestRecords = ref2.requestRecords, requestTransaction = ref2.requestTransaction;
    var collection_owned = collections.filter(function(collection) {
        return token.collection.hex_id === collection.hex_id;
    })[0];
    var handleDropdown = function() {
        window.addEventListener("click", function(w) {
            if (w.target.closest(".trending-dots")) {
                if (dropdownShow) {
                    setDropdownShow(false);
                } else {
                    setDropdownShow(true);
                }
            } else {
                setDropdownShow(false);
            }
        });
    };
    console.log("collection_owned", collection_owned);
    var token_owned = token.owner === publicKey;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (collection_owned || token_owned) && !(!token_owned && collection_owned && !collection_owned.data.updatable) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: handleDropdown,
                        className: "dropdown-toggle trending-dots inline-flex h-10 w-10 items-center justify-center text-sm show",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            width: "16",
                            height: "4",
                            viewBox: "0 0 16 4",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "dark:fill-jacarta-200 fill-jacarta-500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "2",
                                    cy: "2",
                                    r: "2"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "8",
                                    cy: "2",
                                    r: "2"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "14",
                                    cy: "2",
                                    r: "2"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: dropdownShow ? "dropdown-menu-end dark:bg-jacarta-800 z-10 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl show text-jacarta-500 absolute top-full right-0" : "dropdown-menu-end dark:bg-jacarta-800 z-10 min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl hidden text-jacarta-500 absolute top-full right-0",
                        children: [
                            (!is_private || token.collection.public_data.publicizable) && token_owned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/token/".concat(token.hex_id, "/transfer?dest=").concat(is_private ? "public" : "private", "&to=self"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-100 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                        children: [
                                            "Make ",
                                            is_private ? "public" : "private"
                                        ]
                                    })
                                })
                            }),
                            is_private && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            return dispatch((0,_redux_counterSlice__WEBPACK_IMPORTED_MODULE_4__/* .proveModalShow */ .XY)({
                                                token: token._record,
                                                type: "token_ownership"
                                            }));
                                        },
                                        className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-100 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                        children: "Prove token ownership"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            return dispatch((0,_redux_counterSlice__WEBPACK_IMPORTED_MODULE_4__/* .proveModalShow */ .XY)({
                                                token: token._record,
                                                type: "collection_holdership"
                                            }));
                                        },
                                        className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-100 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                        children: "Prove collection holdership"
                                    }),
                                    token.collection.hex_id === "d42d394f5000435e1bc9dc9dc8e5bd01" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            return burnPP(publicKey, requestRecords, requestTransaction, token, router, alert, loading, setLoading);
                                        },
                                        className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-100 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                        children: "Unwrap to original program"
                                    })
                                ]
                            }),
                            collection_owned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: collection_owned.data.updatable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                            className: "dark:bg-jacarta-600 bg-jacarta-100 my-2 mx-4 h-px border-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/token/".concat(token.hex_id, "/edit"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-100 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                                children: "Update token metadata"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: function() {
                                                return dispatch((0,_redux_counterSlice__WEBPACK_IMPORTED_MODULE_4__/* .burnModalShow */ .iT)({
                                                    token: is_private ? token._record : (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_8__/* .token_hex_to_token_id */ .rS)(token.hex_id),
                                                    collection: collection_owned._record,
                                                    is_private: is_private
                                                }));
                                            },
                                            className: "dark:hover:bg-jacarta-600 font-display hover:bg-jacarta-100 block w-full rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white",
                                            children: "Burn token definitively"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Token_dropdown);


/***/ }),

/***/ 5939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _tippyjs_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2697);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var Likes = function(param) {
    var like = param.like, _classes = param.classes, classes = _classes === void 0 ? "dark:bg-jacarta-700 absolute top-3 right-3 flex items-center space-x-1 rounded-md bg-white p-2" : _classes;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(typeof like === "string" ? +like - 1 : like - 1), likeState = ref[0], setLikeState = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(likeState), likeNumber = ref1[0], setlikeNumber = ref1[1];
    var handleLike = function() {
        if (likeState >= likeNumber) {
            setlikeNumber(function(prev) {
                return prev + 1;
            });
        } else {
            setlikeNumber(function(prev) {
                return prev - 1;
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes,
        onClick: handleLike,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tippyjs_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                className: "p-1",
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "Favorite"
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "js-likes relative cursor-pointer",
                    children: likeState === likeNumber ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: "icon icon-heart-fill dark:fill-jacarta-200 fill-jacarta-500 hover:fill-red dark:hover:fill-red h-4 w-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                            xlinkHref: "/icons.svg#icon-hert-fill"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: "icon icon-heart-fill dark:fill-jacarta-200 fill-jacarta-500 hover:fill-red dark:hover:fill-red h-4 w-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                            xlinkHref: "/icons.svg#icon-heart-fill"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "dark:text-jacarta-200 text-sm",
                children: likeNumber
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Likes);


/***/ }),

/***/ 3996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ trendingCategoryData; }
/* harmony export */ });
/* unused harmony export tranding_category_filter */
var tranding_category_filter = [
    {
        id: 0,
        svg: "world",
        text: "public"
    },
    {
        id: 1,
        svg: "domain",
        text: "private"
    },
    {
        id: 2,
        text: "all"
    }, 
];
var trendingCategoryData = [
    {
        image: "/images/products/item_5.jpg",
        id: "Flourishing Cat #1800",
        category: "art",
        title: "Flourishing Cat #180",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 1,
        sortPrice: 8.49,
        price: "From 8.49 ETH",
        bidLimit: 8,
        bidCount: 2,
        likes: 15,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_1.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_1.png"
        }
    },
    {
        image: "/images/products/item_4.jpg",
        id: "Amazing NFT art1",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 2,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_7.jpg",
        id: "SwagFox#1332",
        category: "domain",
        title: "SwagFox#133",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 3,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_6.jpg",
        id: "Splendid Girl3",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: true,
        verified: false,
        addDate: 4,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_8.jpg",
        id: "Monkeyme#1554",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: false,
        lazyMinted: false,
        verified: true,
        addDate: 5,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_9.jpg",
        id: "Jedidia#1495",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 6,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_10.jpg",
        id: "Artof Eve6",
        category: "art",
        title: "Artof Eve",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 7,
        sortPrice: 0.13,
        price: "0.13 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 55,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_7.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna #16497",
        category: "collection",
        title: "Asuna#1649",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 8,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna#164978",
        category: "collection",
        title: "Asuna#1649",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 9,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_12_lg.jpg",
        id: "Amazing NFT art9",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 10,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_13_lg.jpg",
        id: "SwagFox#13310",
        category: "domain",
        title: "SwagFox#133",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 12,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_14_lg.jpg",
        id: "Splendid Girl311",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 13,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_15_lg.jpg",
        id: "Monkeyme#15512",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 14,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_16_lg.jpg",
        id: "Jedidia#14913",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 15,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_5.jpg",
        id: "FlourishingCat#18014",
        category: "art",
        title: "Flourishing Cat #180",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 16,
        sortPrice: 8.49,
        price: "From 8.49 ETH",
        bidLimit: 8,
        bidCount: 2,
        likes: 15,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_1.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_1.png"
        }
    },
    {
        image: "/images/products/item_4.jpg",
        id: "Amazing NFT art15",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 16,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_7.jpg",
        id: "SwagFox#13316",
        category: "domain",
        title: "SwagFox#133",
        nfsw: false,
        lazyMinted: false,
        verified: false,
        addDate: 17,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_6.jpg",
        id: "Splendid Girl7",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 18,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_8.jpg",
        id: "Monkeyme#15548",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 19,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_9.jpg",
        id: "Jedidia#14959",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 20,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_10.jpg",
        id: "Artof Eve60",
        category: "art",
        title: "Artof Eve",
        nfsw: true,
        lazyMinted: false,
        verified: false,
        addDate: 21,
        sortPrice: 0.13,
        price: "0.13 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 55,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_7.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna #164971",
        category: "collection",
        title: "Asuna#1649",
        nfsw: false,
        lazyMinted: true,
        verified: true,
        addDate: 22,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_11.jpg",
        id: "Asuna#1649782",
        category: "collection",
        title: "Asuna#1649",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 23,
        sortPrice: 0.8,
        price: "0.8 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 70,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_8.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_12_lg.jpg",
        id: "Amazing NFT art93",
        category: "Collectibles",
        title: "Amazing NFT art",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 24,
        sortPrice: 5.9,
        price: "From 5.9 ETH",
        bidLimit: 7,
        bidCount: 1,
        likes: 188,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_2.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_2.png"
        }
    },
    {
        image: "/images/products/item_13_lg.jpg",
        id: "SwagFox#133104",
        category: "domain",
        title: "SwagFox#133",
        nfsw: false,
        lazyMinted: true,
        verified: false,
        addDate: 25,
        sortPrice: 0.078,
        price: "0.078 ETH",
        bidLimit: 3,
        bidCount: 1,
        likes: 160,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_3.png"
        }
    },
    {
        image: "/images/products/item_14_lg.jpg",
        id: "Splendid Girl3115",
        category: "music",
        title: "Splendid Girl",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 26,
        sortPrice: 10,
        price: "10 ETH",
        bidLimit: 3,
        bidCount: 2,
        likes: 159,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_4.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    },
    {
        image: "/images/products/item_15_lg.jpg",
        id: "Monkeyme#155126",
        category: "photography",
        title: "Monkeyme#155",
        nfsw: true,
        lazyMinted: false,
        verified: true,
        addDate: 27,
        sortPrice: 5,
        price: "From 5 FLOW",
        bidLimit: 1,
        bidCount: 1,
        likes: 32,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_3.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_5.png"
        }
    },
    {
        image: "/images/products/item_16_lg.jpg",
        id: "Jedidia#149137",
        category: "virtual world",
        title: "Jedidia#149",
        nfsw: false,
        lazyMinted: true,
        verified: false,
        addDate: 28,
        sortPrice: 0.16,
        price: "0.16 ETH",
        bidLimit: 1,
        bidCount: 1,
        likes: 25,
        creator: {
            name: "Sussygirl",
            image: "/images/avatars/creator_6.png"
        },
        owner: {
            name: "Sussygirl",
            image: "/images/avatars/owner_4.png"
        }
    }, 
];



/***/ })

}]);